<template>
  <footer id="contact" class="footer">
    <div class="footer__container">
      <div class="links">
        <div class="link__block">
          <h3>{{ $t("footer.legal") }}</h3>
          <router-link to="/privacy">{{ $t("footer.privacy") }}</router-link>
          <router-link to="/terms">{{ $t("footer.terms") }}</router-link>
          <router-link to="/policy">{{
            $t("footer.subscription")
          }}</router-link>
        </div>

        <div class="link__block">
          <h3>{{ $t("footer.getInTouch") }}</h3>
          <a class="mail" :href="'mailto:' + supportEmail">{{supportEmail}}</a>
          <a href="#" class="mail show-contact-form">{{
            $t("footer.contactUs")
          }}</a>
          <a href="#" class="mail cancel-subscription">{{
            $t("footer.cancelSubscription.title")
          }}</a>
        </div>
      </div>
      <div class="company_block">
        <div class="company_logo">
          <img :src="mediaBaseUrl + 'logo-white.svg'" alt="" />
          <p class="company_name">
            1D3 DIGITECH OÜ is an authorized global distributor of
            dynamic-fitness-pro.com
          </p>
        </div>
        <p class="copyright">Copyright &copy; Cros - Corp Investments Ltd</p>
      </div>
    </div>

    <cancel-subscription></cancel-subscription>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  inject: ["mediaBaseUrl"],
  data() {
    return {
      supportEmail: "support@" + window.location.hostname,
    };
  },
};
</script>

<style lang="sass">
$lg: 700px

.footer
  background: rgba(0, 0, 0, 1)
  width: 100%
  //border-radius: 40px 40px 0 0
//border-top: 1px solid rgba(198, 198, 198, 1)

.footer__container
  display: flex
  flex-direction: column
  gap: 80px
  padding: 60px 16px 58px
  max-width: 1040px
  width: 100%
  margin: 0 auto
  align-items: center
  justify-content: center

  @media screen and (min-width: 905px)
    flex-direction: row
    align-items: flex-start
    justify-content: space-between
    padding-top: 40px
    padding-bottom: 62px
    gap: 70px


  .copyright
    font-weight: 400
    color: #fff
    opacity: 50%
    text-align: right
    margin-top: 26px
  .links
    display: flex
    flex-direction: column
    gap: 40px

    @media screen and (min-width: $lg)
      flex-direction: row
      gap: 135px

  .link__block
    display: flex
    flex-direction: column
    gap: 8px
    max-width: 292px

    p
      color: rgba(255, 255, 255, 1)
      font-size: 1rem
      line-height: 1.5rem
      font-weight: 400

    @media screen and (min-width: $lg)
      justify-content: flex-start

      p
        text-align: left

      h3, a
        text-align: left

    h3
      font-weight: 600
      color: rgba(255, 255, 255, 1)
      font-size: 1.125rem
      line-height: 1.725rem
      margin-bottom: 8px

    a
      text-decoration: none
      font-weight: 400
      font-size: 1rem
      line-height: 1.5rem
      color: rgba(255, 255, 255, 1)
      transition: .3s ease
      cursor: pointer

      &:hover
        color: rgba(255, 255, 255, .6)

      &.mail
        text-decoration: underline

  p
    font-size: 0.875rem
    margin: 0
    color: rgba(255, 255, 255, 1)
.company_block
  width: 100%
  max-width: 435px
  display: flex
  flex-direction: column
  gap: 26px
  align-items: flex-end   
  @media screen and (max-width: 1030px)
    max-width: 355px 
  @media screen and (max-width: 902px)
    max-width: 435px        
    align-items: center      

.company_logo
  display: flex
  gap: 15px
  img
    width: 90px   
  .company_name
    text-align: start   
</style>
